import Alpine from 'alpinejs'
import collapse from '@alpinejs/collapse'

export const initAlpine = () => {
  
  window.Alpine = Alpine

	Alpine.plugin(collapse)
  Alpine.start()

}

export default () => {}